module.exports = __webpack_public_path__ + "assets/icon_campaign_loudspeaker.5603de7f.svg";